import store from "@/app/store/store";
export class CacheHelper {
    static getUserId() {
        return store.getters["loginModule/userId"];
    }
    /**
     * Retrieves an item from localStorage for a specific page.
     * @param pageName
     * @param key
     */
    static getItem(pageName, key) {
        var _a;
        try {
            let model = JSON.parse((_a = localStorage[CacheHelper.getKey(pageName, key)]) !== null && _a !== void 0 ? _a : null);
            return (model === null || model === undefined ? null : model);
        }
        catch (ex) {
            console.error(ex);
            return null;
        }
    }
    ;
    /**
     * Stores an item to locateStorage for a specific page.
     * @param pageName
     * @param key
     * @param query
     */
    static storeItem(pageName, key, query) {
        try {
            let model = JSON.stringify(query);
            localStorage[CacheHelper.getKey(pageName, key)] = model;
        }
        catch (ex) {
            console.error(ex);
        }
    }
    ;
    /**
     * Removes an item from localStorage for a specific page.
     * @param pageName
     * @param key
     */
    static removeItem(pageName, key) {
        localStorage.removeItem(CacheHelper.getKey(pageName, key));
    }
    ;
    static getKey(pageName, key) {
        return `${CacheHelper.rootCacheKey}.${CacheHelper.getUserId()}.${pageName}.${key}`;
    }
    ;
}
CacheHelper.rootCacheKey = "PowerShield.BatteryPortal";
